/**
 * Centralized error logging utility
 * Hook to Sentry/LogRocket/etc. if available
 */

export function logError(scope: string, err: unknown) {
  // Hook to external error tracking if available
  // Example: if (typeof Sentry !== 'undefined') { Sentry.captureException(err); }
  
  console.error(`[${scope}]`, err);
  
  // Optional: send to custom error endpoint
  // fetch('/api/log-error', { method: 'POST', body: JSON.stringify({ scope, error: String(err) }) });
}

export function logWarning(scope: string, message: string, context?: Record<string, unknown>) {
  console.warn(`[${scope}]`, message, context);
}

export function logInfo(scope: string, message: string, context?: Record<string, unknown>) {
  console.info(`[${scope}]`, message, context);
}
